var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgModifyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_970_10524)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7041 7.63246C20.9918 6.34473 23.0796 6.34473 24.3674 7.63247C25.6551 8.9202 25.6551 11.008 24.3674 12.2958L12.7065 23.9567C12.6923 23.9709 12.6782 23.9849 12.6644 23.9988C12.446 24.2175 12.2611 24.4026 12.0418 24.5472C11.8488 24.6745 11.6395 24.7751 11.4195 24.8463C11.1696 24.9272 10.9096 24.9559 10.6024 24.9899C10.5828 24.992 10.5631 24.9942 10.5432 24.9964L7.55485 25.3285C7.31331 25.3553 7.07267 25.2709 6.90082 25.099C6.72898 24.9272 6.64456 24.6865 6.6714 24.445L7.00344 21.4567C7.00565 21.4367 7.00783 21.417 7.00999 21.3975C7.04391 21.0903 7.07263 20.8302 7.15352 20.5803C7.22473 20.3604 7.32534 20.151 7.45262 19.958C7.59721 19.7387 7.78235 19.5539 8.00103 19.3355C8.01494 19.3216 8.02898 19.3076 8.04316 19.2934L19.7041 7.63246ZM23.236 8.76384C22.5731 8.10094 21.4983 8.10094 20.8354 8.76384L9.17453 20.4248C8.89212 20.7072 8.83201 20.7726 8.78834 20.8388C8.74043 20.9115 8.70255 20.9903 8.67575 21.0731C8.65131 21.1486 8.63776 21.2364 8.59365 21.6334L8.37205 23.6278L10.3665 23.4062C10.7635 23.3621 10.8513 23.3485 10.9267 23.3241C11.0095 23.2973 11.0883 23.2594 11.161 23.2115C11.2272 23.1678 11.2927 23.1077 11.5751 22.8253L23.236 11.1644C23.8989 10.5015 23.8989 9.42674 23.236 8.76384Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_970_10524"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModifyIcon);
export default __webpack_public_path__ + "static/media/modifyIcon.21b5743d.svg";
export { ForwardRef as ReactComponent };